__turbopack_context__.v({
  "className": "lato_8921d9e8-module__MbiSSW__className",
  "variable": "lato_8921d9e8-module__MbiSSW__variable",
});
